import { ExternalComponent } from './../external/external.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { InternalComponent } from './internal.component';
import { InternalAccesoComponent } from './internal-acceso/internal-acceso.component';
import { InternalHomeComponent } from './internal-home/internal-home.component';
import { AplicationdefsComponent } from './internal-home/pages/aplicationdefs/aplicationdefs.component';
import { ParametersComponent } from './internal-home/pages/parameters/parameters.component';
import { CasComponent } from './internal-home/pages/cas/cas.component';
import { WsdefsComponent } from './internal-home/pages/wsdefs/wsdefs.component';
import { SetvaluesComponent } from './internal-home/pages/setvalues/setvalues.component';
import { TypefindersComponent } from './internal-home/pages/typefinders/typefinders.component';
import { TyperunsComponent } from './internal-home/pages/typeruns/typeruns.component';
import { XmldefsComponent } from './internal-home/pages/xmldefs/xmldefs.component';
import { FieldtypesComponent } from './internal-home/pages/fieldtypes/fieldtypes.component';
import { FieldlinksComponent } from './internal-home/pages/fieldlinks/fieldlinks.component';
import { DbattrsComponent } from './internal-home/pages/dbattrs/dbattrs.component';
import { DbmodelsComponent } from './internal-home/pages/dbmodels/dbmodels.component';
import { DbindicesComponent } from './internal-home/pages/dbindices/dbindices.component';
import { DbindexfldsComponent } from './internal-home/pages/dbindexflds/dbindexflds.component';
import { TextsComponent } from './internal-home/pages/texts/texts.component';
import { NoticesComponent } from './internal-home/pages/notices/notices.component';
import { StatisticsComponent } from './internal-home/pages/statistics/statistics.component';
import { StatistisexteranlComponent } from './internal-home/pages/statistisexteranl/statistisexteranl.component';
import { CiudadanoModule } from '../external/ciudadano/ciudadano.module';
import { EmpresaModule } from '../external/empresa/empresa.module';
import { ProveedorModule } from '../external/proveedor/proveedor.module';
import { IsLoggedGuard } from '../../core/guards/is-logged.guard';
import { FormPendentGuard } from '../../core/guards/deactivate/form-pendent.guard';
import { WebservicesComponent } from './internal-home/pages/webservices/webservices.component';
import { RolexternalComponent } from './internal-home/pages/rolexternal/rolexternal.component';
import { RolinternalComponent } from './internal-home/pages/rolinternal/rolinternal.component';

const INTERNAL_ROUTE: Routes = [{
  path: '',
  component: InternalComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'acces'
    }
    ,
    {
      path: 'acces',
      component: InternalAccesoComponent,
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home',
      component: InternalHomeComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'passarela',
      // component: ExternalComponent,
      loadChildren: () => CiudadanoModule
    }
    ,
    {
      path: 'empreses',
      // component: ExternalComponent,
      loadChildren: () => EmpresaModule
    }
    ,
    {
      path: 'proveidors',
      // component: ExternalComponent,
      loadChildren: () => ProveedorModule
    }
    ,
    {
      path: 'home/applicationdefs',
      component: AplicationdefsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/parameters',
      component: ParametersComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/cas',
      component: CasComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/wsdefs',
      component: WsdefsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/setvalue_wscategories',
      component: SetvaluesComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/typefinders',
      component: TypefindersComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/typeruns',
      component: TyperunsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/xmldefs',
      component: XmldefsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/fieldtypes',
      component: FieldtypesComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/fieldlinks',
      component: FieldlinksComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/dbattrs',
      component: DbattrsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/dbmodels',
      component: DbmodelsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/dbindices',
      component: DbindicesComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/dbindices/dbindexflds',
      component: DbindexfldsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/webservices',
      component: WebservicesComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/texts',
      component: TextsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/notices',
      component: NoticesComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/statistics',
      component: StatisticsComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/statistisexteranl',
      component: StatistisexteranlComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/rolexternal',
      component: RolexternalComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
    ,
    {
      path: 'home/rolinternal',
      component: RolinternalComponent,
      canActivate: [IsLoggedGuard],
      canDeactivate: [FormPendentGuard],
      data: {
        authorities: [],
        pageTitle: 'INTERNAL.title'
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(INTERNAL_ROUTE)],
  exports: [RouterModule]
})
export class InternalRoutingModule { }
